import messages from './myDataDeletion.json' with { type: 'json' };

export const myDataDeletionEn: Readonly<typeof messages> = messages;
